<template>
	<el-card class="pay" :class="{ otherPayBg: !isShowBalance }">
		<div :class="{ otherPay: !isShowBalance }">
			<div class="pay-body">
				<h2 v-if="isShowBalance">{{ isOnPay ? 'Billing details' : 'Payment successful' }}</h2>
				<div v-else style="margin-top: 10px">{{ isOnPay ? 'Billing details' : 'Payment successful' }}</div>
				<el-divider></el-divider>
				<div v-if="tabData.length > 0">
					<h4>Product information</h4>
					<el-table :data="tabData" :span-method="mergeRows" :header-cell-style="{ background: '#eef1f6' }">
						<el-table-column
							v-for="(item, idx) in tabColumn"
							:key="idx"
							:prop="item.prop"
							:label="item.label"
							:align="item.align"
						>
							<template slot-scope="scope">
								<span v-if="item.isStatus">
									<!-- 切换状态显示已付款和待支付 -->
									{{ scope.row[item.prop] == 2 ? 'Unpaid' : 'Paid' }}
								</span>
								<span v-else>
									{{ scope.row[item.prop] }}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<h4 v-if="isShowBalance">Order information</h4>
				<span v-else>Order information</span>
				<el-divider></el-divider>
				<div class="commodity">
					<div class="commodity-left">
						<div>
							<div class="commodity-tit">Order No.:</div>
							<span>{{ orderPay.orderNo }}</span>
						</div>
						<div>
							<span class="commodity-tit"> Product:</span><span>{{ orderPay.productName }}</span>
						</div>
						<div v-if="isShowDiscount">
							<span class="commodity-tit">Coupon:</span>
							<span class="selectdiscount">
								<a @click="discountsadd" :class="isOnPay ? 'commodity-color' : 'pay-finish'" href="#">
									{{ useCoupon }}
								</a>
							</span>
						</div>
					</div>
					<div class="commodity-right" :class="{ fs14: isShowBalance }">
						<div v-if="isShowBalance">
							<span class="commodity-tit">Order amount:</span><span>${{ orderPay.price }}</span>
						</div>
						<div v-if="isShowBalance">
							<span class="commodity-tit">Discount:</span><span>${{ discountssum }}</span>
						</div>
						<div>
							<span class="commodity-tit"> Payable:</span
							><span class="pay-price" :class="{ xigua: !isShowBalance }"
								>$<b :class="{ fs20: isShowBalance }">
									{{ ultimatelyPay }}
								</b>
							</span>
						</div>
					</div>
				</div>
				<!-- 未支付 -->
				<div v-if="isOnPay" class="pay-body-content fs14">
					<div style="padding: 20px 0">
						<b>Payment method:</b>
						<el-radio-group v-model="purchaseWay" @change="reqregions">
							<!-- <el-radio label="alipay" border>
								<img src="@/assets/images/zfbicon.png" class="servers_icon" />支付宝
							</el-radio> -->
							<el-radio label="shopify" border>
								<img src="@/assets/images/shopify.png" class="servers_icon" />shopify
							</el-radio>
							<el-radio v-if="type !== 2 && isShowBalance" label="balance" border>
								<img src="@/assets/images/balance.png" class="servers_icon" />余额
							</el-radio>
						</el-radio-group>
					</div>
					<!-- 支付宝支付 -->
					<div v-if="patternPay == 'alipay'">
						<div class="qrcode">
							<div style="font-size: 12px">此订单还未支付，请用支付宝扫描以下二维码进行支付</div>
							<div style="width: 200px; height: 200px">
								<vue-qr
									:text="orderPay.qrcode"
									:margin="0"
									colorDark="#000"
									colorLight="#fff"
									:logoScale="0.22"
									:size="200"
									:logoSrc="orderPay.icon"
								></vue-qr>
								<!-- 
							<img :src="orderPay.qrcode" style="width: 100%" /> -->
							</div>
						</div>
					</div>
					<!-- 余额支付 -->
					<div v-if="patternPay == 'balance'">
						<div class="balance" style="font-size: 14px">
							可用余额：<span class="balance_size">{{ balanceMoney }}</span
							>{{ $MONEY_NAME }}
						</div>
						<div class="balance" style="font-size: 14px">
							支付金额：<span class="balance_size">{{ ultimatelyPay }}</span
							>{{ $MONEY_NAME }}
						</div>
						<div style="text-align: center; margin-top: 20px">
							<el-button v-if="truebalance" type="primary" size="small" @click="balancePay"
								>购买</el-button
							>
							<el-button v-else type="primary" size="small" @click="$router.push('/rechargepay')"
								>充值</el-button
							>
						</div>
					</div>
				</div>

				<!-- 已支付 -->
				<div v-else class="fs14">
					<div class="qrcode">
						<div style="width: 180px; height: 180px">
							<img src="@/assets/images/paysucc.png" style="width: 100%" />
						</div>
						<div><b>支付成功</b></div>
						<div class="reminder">订单生成可能存在延迟，请耐心等待</div>
						<div style="margin-top: 20px">
							<el-button size="medium" plain round @click="goHome">返回</el-button>
						</div>
					</div>
				</div>
			</div>
			<!-- 优惠券弹窗 -->
			<el-dialog :visible.sync="dialogVisible" width="50%" :before-close="handleClose" top="30vh">
				<div class="discounts_title" slot="title">-优惠券-</div>
				<el-table
					:data="tableData"
					style="width: 100%"
					:header-cell-style="{ background: '#eef1f6' }"
					empty-text="暂无优惠券"
				>
					<el-table-column width="25">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.radio" @change="discountsChange(scope.row)"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="name" label="优惠券名称" align="center"> </el-table-column>
					<el-table-column prop="couponAmount" label="券面金额" align="center"> </el-table-column>
					<el-table-column prop="category" label="适用项目" align="center"> </el-table-column>
					<el-table-column label="有效日期" align="center" width="250">
						<template slot-scope="scope">
							<div>{{ scope.row.effectiveStart }} - {{ scope.row.effectiveEnd }}</div>
						</template>
					</el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button size="small " @click="dialogVisible = false">取 消</el-button>
					<el-button size="small " type="primary" @click="changeadd">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</el-card>
</template>

<script>
import {
	opderDetail,
	Pay,
	Payinfo,
	Coupon,
	usage,
	userInfo,
	cancel,
	remainPage,
	create,
	getTokenByErp,
} from '@/utils/api'
import { Message } from 'element-ui'
import vueQr from 'vue-qr'
import { getMergrAry } from '@/utils'

export default {
	components: {
		vueQr,
	},
	data() {
		return {
			type: null,
			tableData: [],
			currentRow: null,
			dialogVisible: false,
			orderPay: {
				orderNo: '',
				payment: '',
				price: 0,
				productName: '',
				qrcode: '',
				icon: '',
			},
			discountssum: 0,
			payInfoTimer: null,
			isOnPay: true,
			isShowDiscount: false, //优惠券显示与隐藏
			useCoupon: '使用优惠券',
			ultimatelyPay: 0, //最后金额
			purchaseWay: 'balance', //购买方式
			patternPay: 'balance', //相应支付页面显示
			balanceMoney: 0, //账户余额
			repCoupon: null, //上次使用的优惠券
			truebalance: true,
			beforeUnloadTime: null,
			gapTime: null,
			setTimer: null,
			tabData: [],
			tabColumn: [
				{
					prop: 'billDate',
					label: '日期',
					align: 'left',
				},
				{
					prop: 'waybillNum',
					label: '运单号',
					align: 'center',
				},
				{
					prop: 'relatedWayBill',
					label: '关联运单号',
					align: 'center',
				},
				{
					prop: 'transferNum',
					label: '转单号',
					align: 'center',
				},
				{
					prop: 'serverType',
					label: '服务类型',
					align: 'center',
				},
				{
					prop: 'country',
					label: '发往国家',
					align: 'center',
				},
				{
					prop: 'postCode',
					label: '邮编',
					align: 'center',
				},
				{
					prop: 'num',
					label: '件数',
					align: 'center',
				},
				{
					prop: 'payWeight',
					label: '收费重量（KG）',
					align: 'center',
				},
				{
					prop: 'billType',
					label: '费用类型',
					align: 'center',
				},
				{
					prop: 'unit',
					label: '单价（元）',
					align: 'center',
				},
				{
					prop: 'currency',
					label: '币种',
					align: 'center',
				},
				{
					prop: 'price',
					label: '金额（元）',
					align: 'center',
				},
			],
			mergeAry: [],
			orderNo: null,
			isShowBalance: true,
			// mergeFlag: 0,
		}
	},
	mounted() {
		/**
		 * 马帮应用市场跳转支付页面传参orderNo
		 */

		if (this.$route.query.orderNo) {
			this.orderNo = this.$route.query.orderNo
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
				remain_time: '5',
				page_url: this.$route.path,
				page_describe: '支付页面长时间停留',
			}
			this.setTimer = window.setTimeout(() => {
				remainPage(params)
			}, 300000)
			this.balance()
			this.reqcreate()
			this.reqPayinfo()
		} else {
			// 第三方跳转支付页面传参goodsId，buyNum，source
			this.isShowBalance = false
			this.login()
		}
	},
	destroyed() {
		window.clearInterval(this.payInfoTimer)
		window.clearTimeout(this.setTimer)
		this.cancels()
	},
	methods: {
		cancels() {
			let params = {
				orderNo: this.orderPay.orderNo,
			}
			cancel(params).then(() => {})
		},
		login() {
			// let loginInfo = {
			// 	ProjectId: this.$route.query.ProjectId,
			// 	action: this.$route.query.action,
			// 	appid: this.$route.query.appid,
			// 	editionId: this.$route.query.editionId,
			// 	sourceId: this.$route.query.sourceId,
			// 	timestamp: this.$route.query.timestamp,
			// 	token: this.$route.query.token,
			// 	version: this.$route.query.version,
			// 	sign: this.$route.query.sign,
			// }
			getTokenByErp(this.$route.query).then((res) => {
				sessionStorage.setItem('mabangerp_token', res.token)
				let params = {
					goodsId: this.$route.query.goodsId,
					buyNum: this.$route.query.buyNum,
					source: this.$route.query.sourceId,
				}
				create(params).then((res) => {
					this.orderNo = res.orderNo
					this.reqPayinfo()
					this.orderDetailList()
				})
			})
		},

		//选择购买方式
		reqregions(val) {
			this.patternPay = val
			if (val == 'alipay') {
				this.mabangPays()
				this.reqPayinfo()
			} else if (val === 'shopify') {
				this.mabangPays('shopify', 'shopifyBill')
				this.reqPayinfo()
			} else if (val == 'balance') {
				window.clearInterval(this.payInfoTimer)
			}
		},
		//余额支付
		balancePay() {
			if (this.balanceMoney < this.ultimatelyPay) {
				this.$message.warning('余额不足')
			} else {
				this.$confirm(`可用余额 ${this.balanceMoney} 元，支付金额 ${this.ultimatelyPay} 元。`, '确认购买', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'success',
				})
					.then(() => {
						this.reqPayinfo()
						this.mabangPays()
					})
					.catch(() => {
						window.clearInterval(this.payInfoTimer)
						this.$message.warning('支付失败！')
					})
			}
		},
		//账户信息
		balance() {
			let params = {
				source: JSON.parse(sessionStorage.getItem('sourceInfo')).sourceId,
			}
			userInfo(params).then((res) => {
				this.balanceMoney = res.amount
			})
		},
		//查询支付状态
		reqPayinfo() {
			this.payInfoTimer = window.setInterval(() => {
				let params = {
					orderNo: this.orderPay.orderNo,
				}
				if (this.orderPay.orderNo !== '') {
					Payinfo(params).then((res) => {
						if (res.payed === 1) {
							this.isOnPay = false
							window.clearInterval(this.payInfoTimer)
							window.clearTimeout(this.setTimer)

							if (!this.isShowBalance) {
								// 西瓜跨境跳转进来的
								window.location.href = `https://www.xiguakuajing.com/hatch-camp/buy-results?type=hatch&order_no=${this.orderNo}`
							}
						}
					})
				}
			}, 2000)
		},
		reqcreate() {
			if (this.$route.query.moduleId == 5) {
				this.isShowDiscount = true
				//优惠券
				this.reqCoupon()
			} else {
				this.isShowDiscount = false
			}
			this.orderDetailList()
		},
		//支付
		mabangPays() {
			let params = {
				orderNo: this.orderNo,
				payment: this.purchaseWay,
			}
			if (this.purchaseWay == 'alipay') {
				params.payScene = 'scanQrcode'
			} else if (this.purchaseWay == 'balance') {
				params.payScene = 'deduction'
			} else if (this.purchaseWay === 'shopify') {
				params.payScene = 'shopifyBill'
			}
			Pay(params)
				.then((res) => {
					if (res) {
						this.orderPay.icon = require('../../assets/images/alipay.png')
						this.orderPay.qrcode = res.qrcode
					}
					if (this.purchaseWay === 'shopify') {
						window.open(res.qrcode)
					}
					/**
					 * axios配置了如果余额不足返回 1
					 * 此处判断是否显示充值按钮
					 */
					if (res == 1) {
						this.truebalance = false
					}
				})
				.catch(() => {
					if (this.patternPay == 'balance') {
						window.clearInterval(this.payInfoTimer)
					}
				})
		},
		//详情
		orderDetailList() {
			let params = {
				orderNo: this.orderNo,
			}
			opderDetail(params).then((res) => {
				this.orderPay.productName = res.productName
				this.orderPay.price = res.totalAmount
				this.ultimatelyPay = res.amount
				this.orderPay.orderNo = this.orderNo
				this.type = res.type
				/**
				 * 由于table表格需要合并行
				 * 所以需要处理res.productInfo.pays数组为适合table表格使用的数组
				 */
				if (res.productInfo && res.productInfo.pays) {
					res.productInfo.pays.forEach((pay) => {
						let obj = Object.assign(res.productInfo, pay)
						this.tabData.push({ ...obj })
					})
					this.mergeAry = getMergrAry(this.tabData, 'customerId')
				}
				if (!res.payed_at) {
					this.mabangPays()
				}
			})
		},

		//优惠券列表
		reqCoupon() {
			let params = {
				moduleId: this.$route.query.moduleId,
				perPage: 500,
			}
			Coupon(params).then((res) => {
				if (res.data.length == 0) {
					this.isShowDiscount = false
					return
				}
				res.data.forEach((item) => {
					item.radio = false
				})
				this.tableData = res.data
			})
		},
		//优惠券选择
		discountsChange(row) {
			this.tableData.forEach((item) => {
				if (item.id !== row.id) {
					item.radio = false
				}
			})
		},
		//优惠券确定
		changeadd() {
			let arr = this.tableData.filter((item) => item.radio === true)
			if (arr.length === 0) {
				Message.error({ message: '请选择优惠券!' })
				return
			}
			this.requsage(arr[0].couponNo, arr[0].couponAmount, arr[0].name)
		},
		//优惠券刷新
		requsage(couponNo, couponAmount, name) {
			let params = {
				orderNo: this.orderPay.orderNo,
				couponNo: couponNo,
				repCoupon: this.repCoupon,
			}
			usage(params).then((res) => {
				if (!res) return
				this.ultimatelyPay = res.price
				this.handleClose()
				this.mabangPays()
				this.discountssum = couponAmount
				this.useCoupon = name
				this.repCoupon = couponNo
			})
		},
		discountsadd() {
			if (!this.isOnPay) return
			this.dialogVisible = true
		},
		handleClose() {
			this.dialogVisible = false
		},
		goHome() {
			this.$router.go(-1)
		},
		/** 合并table表格行 */
		// eslint-disable-next-line no-unused-vars
		mergeRows({ row, column, rowIndex, columnIndex }) {
			if (columnIndex < 9) {
				const _row = this.mergeAry[rowIndex]
				const _col = _row > 0 ? 1 : 0
				console.log(`rowspan:${_row} colspan:${_col}`)
				return {
					// [0,0] 表示这一行不显示， [2,1]表示行的合并数
					rowspan: _row,
					colspan: _col,
				}
			}
		},
	},
}
</script>

<style scoped>
.pay {
	min-height: 100%;
	border: 0;
}
.otherPayBg {
	background-color: #f3f3f3;
	min-height: 100%;
	border: 0;
	font-size: 18px;
}
.xigua {
	font-size: 34px;
}
.otherPay {
	min-height: 100%;
	border: 0;
	width: 1280px;
	margin: 0 auto;
	background-color: #fff;
	padding-top: 10px;
}
.pay-header {
	width: 100%;
	height: 50px;
}
.pay-breadcrumb {
	width: 80%;
	margin: 0 auto;
}
.el-breadcrumb {
	line-height: 50px;
}
.pay-body {
	width: 90%;
	margin: 0 auto;
}
.pay-body-content {
	padding: 10px 30px 0;
	line-height: 40px;
}

/* .pay-body-title {
	line-height: 60px;
	padding-left: 30px;
	border-bottom: 1px solid #ccc;
} */
.pay-price {
	color: #e69752;
}
.qrcode {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* padding: 50px 0; */
	padding-bottom: 40px;
}
.balance {
	text-align: center;
}
.balance_size {
	font-size: 16px;
	margin: 0 5px;
}

.commodity {
	line-height: 60px;
	padding: 0 30px;
	border-bottom: 1px solid #ccc;
	display: flex;
	justify-content: space-between;
}
.commodity-right {
	align-self: flex-end;
	line-height: 30px;
	/* font-size: 14px; */
}
.commodity-tit {
	display: inline-block;
	width: 120px;
	text-align: right;
}
.discounts_title {
	font-size: 20px;
	text-align: center;
	margin-top: 20px;
}
.el-table >>> .cell {
	font-weight: 500;
}
.el-table >>> td,
.el-table >>> th {
	padding: 5px 0;
}
.pay-finish {
	color: #ccc;
	text-decoration: none;
	cursor: default;
}
.reminder {
	font-size: 12px;
	text-align: center;
	margin-top: 10px;
}
.pay >>> .el-radio__input {
	display: none;
}
.pay >>> .el-radio.is-bordered {
	background-color: #fff;
	padding: 0px 20px 0 10px;
	line-height: 40px;
	text-align: center;
	width: 120px;
}
.pay >>> .el-radio.is-bordered.is-checked {
	background-color: #f1f4f8;
}
.pay >>> .el-radio.is-bordered + .el-radio.is-bordered {
	margin-left: 0px;
}
.radio >>> .el-radio__input {
	display: inline;
}
.servers_icon {
	width: 28px;
	vertical-align: middle;
	margin-right: 10px;
	padding-bottom: 3px;
}
.pay >>> .el-button--primary {
	color: #fff;
	background-color: #e69752;
	border-color: #e69752;
}
</style>
